import * as fb from './facebookEvents';
import * as userEvents from './userEvents';
import * as userProfile from './userProfile';

fb.viewContent();
userEvents.addToCart();
userEvents.initiateCheckout();
userEvents.paymentComplete();
userEvents.productSearch();
userEvents.trackReOrders();
userEvents.clubSignupComplete();
userProfile.setUserProfile();
